module.exports = __webpack_public_path__ + "img/Sectors_Environmental_Recreational.78b2fa98.jpg";